import { END_POINT } from "constants/apiConstant";
import { apiGet } from "../utils/apiUtils";
const {
  RECENT_BOM_API
} = END_POINT;

export const getRecentBomAPI = async () => {
  const response = await apiGet(RECENT_BOM_API);
  console.log("BOM-Status-Api", response);
  if (response.status && response.data) {
    return {
      status: true,
      data: {
        bom: response.data.bom || response.bom,
        bom_items: response.data.bom_items || response.bom_items,
        distributorMin: response.data.DistributorMinimumPrice || response.DistributorMinimumPrice,
      },
      message: response.message,
    };
  }
  return response;
};